<app-header></app-header>
<div class="loading-container">
    <div class="spinner"></div>
    <p>Cargando...</p>
</div>
  